import { Component, Input, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {
  @Input() testimonials: any[] = [];
  activeSlide = 0;
  constructor() { }

  ngOnInit(): void {
    if (!this.testimonials || this.testimonials.length === 0) {
      this.testimonials = this.defaultTestimonials;
    }
  }

  ngAfterViewInit(): void {
    $('#testi').on('slid.bs.carousel', (event: any) => {
      this.activeSlide = event.to;
    });
  }

  defaultTestimonials = [
    {
      "author": "Hugo Alberto Rivera Rodriguez",
      "designation": "Assistenzprofessor, Universidad del Rosario, Kolumbien",
      "message": "Dank Trinka konnte ich meine veröffentlichten Artikel verbessern. Zudem erhielt ich Vorschläge für Fachzeitschriften, die zu meiner Forschung passen.",
      "photo": "clientPhotos/hugo.webp"
    },
    {
      "author": "Dr. Nkhenso Sibuyi ",
      "designation": "Kommissarische Geschäftsführerin: Bibliothek und Informationszentrum <br/>Mitglied der Führungsebene für Forschung und Innovation, Universität Johannesburg",
      "message": "Wir gehen nun in das dritte Jahr unserer Partnerschaft mit Trinka AI; diese Zusammenarbeit hat die Bemühungen unserer Bibliothek und unseres Informationszentrums zur Unterstützung des akademischen Schreibens positiv beeinflusst. Als wir das Tool einführten, war es unser Ziel, Studierenden und Forschenden Ressourcen an die Hand zu geben, mit denen sie die Qualität ihrer Arbeiten steigern können. Seither unterstützt die Plattform verschiedene Phasen des wissenschaftlichen Schreibprozesses, darunter die sprachliche Optimierung und die Vorbereitung auf die Veröffentlichung. Diese Partnerschaft ist Teil unseres umfassenderen Engagements, die Angebote zur Forschungsunterstützung an der Universität zu stärken.",
      "photo": "clientPhotos/nkhenso.webp"
    },
    {
      "author": "Michal Plaček",
      "designation": "Professor für öffentliche und soziale Politik an der Karls-Universität Prag,<br/> Tschechische Republik",
      "message": "Trinka hat die Arbeit an meiner Forschung erheblich effizienter gestaltet. Als Nicht-Muttersprachlerin habe ich vor der Fertigstellung des Artikels früher einen Lektoratsservice in Anspruch genommen – ein Prozess, der Wochen dauerte und viel Geld kostete. Dank Trinka kann ich nun deutlich mehr Zeit in die eigentliche Forschungsarbeit investieren.",
      "photo": "clientPhotos/michal.jpg"
    },
    {
      "author": "Dmitry Belousov",
      "designation": "Leitender Redakteur, Verlag OKI",
      "message": "Ich nutze Trinka bereits seit einigen Jahren und habe einen sehr positiven Eindruck gewonnen. Das Tool trägt maßgeblich zur Verbesserung der Schreibqualität bei. Besonders gut gefällt mir die Grammatik- und Stilprüfung, die nicht nur Fehler aufdeckt, sondern auch konkrete Verbesserungsvorschläge liefert. Die intuitive Benutzeroberfläche ist ein großer Vorteil, insbesondere für neue Nutzer. Trinka ist ein vielseitiges Werkzeug für Fachleute im Publikationswesen. Ich kann es jedem empfehlen, der seine Schreibkompetenz verbessern möchte.",
      "photo": "clientPhotos/dmitry-belousov.png"
    },
    {
      "author": "Angela Reddemann",
      "designation": "Professorin für Theologische Anthropologie am Theologischen Institut VERBUM DEI – San Pablo<br/>Loeches – Madrid, Spanien",
      "message": "Ich bin auf Trinka gestoßen, als ich nach einem zuverlässigen Begleiter suchte, um die korrekte Veröffentlichung meiner Universitätskurse und Bücher über die Spiritualität der Kontemplation zu gewährleisten. Mit einem Premium-Konto kann ich Grammatik und Textfluss meiner Manuskripte in Spanisch, Englisch und Deutsch überarbeiten. Der Kundenservice ist hervorragend und bietet sogar Unterstützung per Zoom an, wenn ich Hilfe benötige oder Änderungen vornehmen muss. Trinka arbeitet schnell, entwickelt sich ständig weiter und überrascht immer wieder mit neuen Funktionen. Einfach klasse!",
      "photo": "clientPhotos/angela-reddemann.png"
    },
    {
      "author": "Raquel Rodrigues",
      "designation": "Doktorandin, Universidade Federal de Minas Gerais, Brasilien",
      "message": "Trinka hat mir sehr geholfen – nicht nur bei der Grammatik, sondern auch bei der Kohäsion und Kohärenz meiner Texte. Die Funktionen zur Plagiats- und Referenzprüfung sind wirklich gut.",
      "photo": "clientPhotos/raquel_rodrigues.jpg"
    },
    {
      "author": "Ömer-Faruk Kafali",
      "designation": "Assistenzprofessor, Ibn Haldun University (Juristische Fakultät), Lehrstuhl für Zivilprozessrecht sowie Zwangsvollstreckungs- und Insolvenzrecht, Türkei",
      "message": "Trinka ist zu einem unverzichtbaren Werkzeug in meinem Arbeitsablauf geworden. Es hilft mir wirklich dabei, komplexe Argumente zu verfeinern und mit größtmöglicher Klarheit darzulegen, wodurch ich beim Überarbeitungsprozess wertvolle Zeit spare.",
      "photo": "clientPhotos/omer-faruk.webp"
    },
    {
      "author": "Ikele, Chinyere Mary-Cynthia",
      "designation": "Wissenschaftliche Mitarbeiterin, Universität Osaka, Japan",
      "message": "Ich war beeindruckt von der schnellen Präzision und dem kostenlosen Guthaben, das Erstnutzern gewährt wird. Zudem veranstaltet Trinka gelegentlich Workshops, von denen ich sehr profitiert habe.",
      "photo": "clientPhotos/Mary-Cynthia.webp"
    },
    {
      "author": "Theo van Leeuwen",
      "designation": "Manager bei Rio Tinto Exploration (Südostasien/Indonesien)",
      "message": "Ich nutze Trinka schon seit einigen Jahren zur Überprüfung meiner wissenschaftlichen Texte (Geologie). Im Vergleich zu einigen anderen Programmen, die ich ausprobiert habe, lieferte Trinka die besten Ergebnisse. Auch der Service bei der Beantwortung von Fragen war ausgezeichnet.",
      "photo": "clientPhotos/theo-van-leeuwen.jpg"
    },
    {
      "author": "Abdi Yusuf",
      "designation": "Universität Jijiga – Dozent und Leiter der Personalabteilung (HRM)",
      "message": "Ich nutze Trinka nun seit einem Jahr, und es hat meinen Schreibprozess erheblich verbessert. Die ausgefeilten Vorschläge zu Grammatik und Stil haben mir geholfen, meine Texte zu verfeinern und ihnen einen professionelleren Schliff zu verleihen. Trinka ist nicht nur ein Werkzeug, sondern ein unverzichtbarer Begleiter für alle, die die Qualität ihrer Texte steigern möchten. Ich kann es jedem wärmstens empfehlen, der Wert auf Klarheit und Präzision beim Schreiben legt.",
      "photo": "clientPhotos/abdi-yusuf.jpg"
    },
    {
      "author": "Rosa Diaz Sandoval",
      "designation": "Promovierte Physikerin und Mathematikerin, Mexiko",
      "message": "Texte mit korrekter englischer Grammatik und angemessenem Stil zu verfassen, ist für Nicht-Muttersprachler keine leichte Aufgabe. Oft übersieht man – besonders bei wissenschaftlichen Arbeiten – kleine Fehler im Dokument, wenn man keine Unterstützung hat. Ich habe Trinka AI als Tool zur automatischen Korrektur ausprobiert und war sehr zufrieden mit den Korrekturvorschlägen und dem Feedback. Dank des Feedbacks versteht man, warum die vorgeschlagene Änderung sinnvoll ist.",
      "photo": "clientPhotos/Rosa-Diaz-Sandoval.jpg"
    }
  ]; 

}
